export const PICKEM_SPORTS = ['NBA', 'WNBA', 'AFL', 'MLB', 'NFL']

export const SPORT_DISPLAY_NAMES = {
  NBA:  'NBA',
  WNBA: 'WNBA',
  AFL:  'AFL',
  MLB:  'MLB',
  NFL:  'NFL',
  NHL:  'NHL',
}

export const LEG_OPTIONS = [
  { value: '2',  label: '2 Legs',  threshold: 1.790, payout: 3.2   },
  { value: '3',  label: '3 Legs',  threshold: 1.867, payout: 6.5   },
  { value: '4',  label: '4 Legs',  threshold: 1.861, payout: 12    },
  { value: '5',  label: '5 Legs',  threshold: 1.903, payout: 25    },
  { value: '6',  label: '6 Legs',  threshold: 1.849, payout: 40    },
  { value: '7',  label: '7 Legs',  threshold: 1.870, payout: 80    },
  { value: '8',  label: '8 Legs',  threshold: 1.870, payout: 150   },
  { value: '9',  label: '9 Legs',  threshold: 1.867, payout: 275   },
  { value: '10', label: '10 Legs', threshold: 1.862, payout: 500   },
  { value: '11', label: '11 Legs', threshold: 1.874, payout: 1000  },
  { value: '12', label: '12 Legs', threshold: 1.839, payout: 1500  },
]

export const MARKET_TYPE_DISPLAY = {
  player_points:                    'Points',
  player_rebounds:                  'Rebounds',
  player_assists:                   'Assists',
  player_steals:                    'Steals',
  player_blocks:                    'Blocks',
  player_threes:                    'Threes',
  player_made_threes:               'Threes',
  player_points_rebounds_assists:   'Points + Rebounds + Assists',
  player_points_rebounds:           'Points + Rebounds',
  player_points_assists:            'Points + Assists',
  player_rebounds_assists:          'Rebounds + Assists',
  player_disposals:                 'Disposals',
  batter_hits:                      'Hits',
  batter_home_runs:                 'Home Runs',
  batter_rbis:                      'RBIs',
  batter_runs:                      'Runs',
  batter_singles:                   'Singles',
  batter_total_bases:               'Total Bases',
  batter_walks:                     'Batter Walks',
  batter_hits_runs_rbis:            'Hits + Runs + RBIs',
  pitcher_strikeouts:               'Pitcher Strikeouts',
  pitcher_outs:                     'Pitcher Outs',
  pitcher_hits_allowed:             'Pitcher Hits Allowed',
  pitcher_earned_runs:              'Pitcher Earned Runs',
  pitcher_walks_allowed:            'Pitcher Walks',
  // NFL - the 18 canonical player O/U keys. Dabble does not currently price
  // every one of them as a Pick'Em prop, but an unused entry is harmless and a
  // missing one renders the raw key (e.g. "player_receiving_yds") to the user.
  player_passing_yds:               'Passing Yards',
  player_passing_tds:               'Passing TDs',
  player_passing_completions:       'Passing Completions',
  player_passing_attempts:          'Passing Attempts',
  player_passing_interceptions:     'Interceptions',
  player_longest_pass:              'Longest Pass',
  player_passing_rushing_yds:       'Passing + Rushing Yards',
  player_rushing_yds:               'Rushing Yards',
  player_rushing_attempts:          'Rushing Attempts',
  player_longest_rush:              'Longest Rush',
  player_rushing_receiving_yds:     'Rushing + Receiving Yards',
  player_receiving_yds:             'Receiving Yards',
  player_receptions:                'Receptions',
  player_longest_reception:         'Longest Reception',
  player_tackles_assists:           'Tackles + Assists',
  player_sacks:                     'Sacks',
  player_kicking_points:            'Kicking Points',
  player_field_goals_made:          'Field Goals Made',
}

export const SELECTION_SHORT_NAMES = {
  player_points_rebounds_assists:   'PRA',
  player_points_rebounds:           'PR',
  player_points_assists:            'PA',
  player_rebounds_assists:          'RA',
  player_points:                    'Points',
  player_rebounds:                  'Rebounds',
  player_assists:                   'Assists',
  player_steals:                    'Steals',
  player_blocks:                    'Blocks',
  player_threes:                    'Threes',
  player_made_threes:               'Threes',
  player_disposals:                 'Disposals',
  batter_hits:                      'Hits',
  batter_home_runs:                 'HRs',
  batter_rbis:                      'RBIs',
  batter_runs:                      'Runs',
  batter_singles:                   'Singles',
  batter_total_bases:               'TB',
  batter_walks:                     'Walks',
  batter_hits_runs_rbis:            'H+R+RBI',
  pitcher_strikeouts:               'Ks',
  pitcher_outs:                     'Outs',
  pitcher_hits_allowed:             'Hits Allowed',
  pitcher_earned_runs:              'ER',
  pitcher_walks_allowed:            'Walks',
  // NFL. These are the compact forms used inside a selection line
  // ("Evan Engram Over 2.5 Receptions"), so they stay short.
  player_passing_yds:               'Pass Yds',
  player_passing_tds:               'Pass TDs',
  player_passing_completions:       'Completions',
  player_passing_attempts:          'Pass Att',
  player_passing_interceptions:     'INTs',
  player_longest_pass:              'Longest Pass',
  player_passing_rushing_yds:       'Pass+Rush Yds',
  player_rushing_yds:               'Rush Yds',
  player_rushing_attempts:          'Rush Att',
  player_longest_rush:              'Longest Rush',
  player_rushing_receiving_yds:     'Rush+Rec Yds',
  player_receiving_yds:             'Rec Yds',
  player_receptions:                'Receptions',
  player_longest_reception:         'Longest Rec',
  player_tackles_assists:           'Tackles+Ast',
  player_sacks:                     'Sacks',
  player_kicking_points:            'Kicking Pts',
  player_field_goals_made:          'FGs Made',
}

export const DEFAULT_FILTERS = {
  sports:     new Set(PICKEM_SPORTS),
  ev:         [0, 50],
  hoursUntil: [0, 24],
  minBooks:   4,
  legCount:   '5',
}

// ─── Pure helpers ─────────────────────────────────────────────────────────────

export const getMarketDisplay = (marketType) =>
  MARKET_TYPE_DISPLAY[marketType] || marketType

export const formatSelection = (selection, marketType) => {
  if (!selection || !marketType) return selection
  const shortName = SELECTION_SHORT_NAMES[marketType] || marketType
  const m = selection.match(/^(.+?\s)?(Over|Under)\s+([\d.]+)/)
  if (m) {
    const playerName = m[1] || ''
    return `${playerName}${m[2]} ${m[3]} ${shortName}`
  }
  return selection
}

export const getEVForLegs = (evByLegs, legCount) => {
  if (!evByLegs || typeof evByLegs !== 'object') return { ev: null }
  const ev = evByLegs[String(legCount)]
  return { ev: ev !== undefined ? ev : null }
}

export const getThresholdOdds = (legCount) => {
  const opt = LEG_OPTIONS.find(o => o.value === String(legCount))
  return opt?.threshold || null
}

export const getPayout = (legCount) => {
  const opt = LEG_OPTIONS.find(o => o.value === String(legCount))
  return opt?.payout || null
}

export const formatDateTime = (ts) =>
  new Date(ts + 'Z').toLocaleString('en-US', {
    month: 'short', day: 'numeric',
    hour: 'numeric', minute: '2-digit', hour12: true,
  })

export const getHoursUntilStart = (ts) => {
  const diff = new Date(ts + 'Z') - new Date()
  return Math.max(0, diff / (1000 * 60 * 60))
}

export const getEVClass = (ev) => {
  if (ev === null || ev === undefined) return 'bc-ev-badge'
  if (ev >= 10) return 'bc-ev-badge bc-ev-high'
  if (ev >= 5)  return 'bc-ev-badge bc-ev-mid'
  return 'bc-ev-badge bc-ev-low'
}
